import {Modal} from "ngx-modal";
import { Component, OnInit, EventEmitter, SimpleChanges, ViewChild, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {PrintSettings} from "../models/print-settings";
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { PdfService } from "../../shared/services/pdf.service";
import { AlertService } from "../../shared/services/alert.service";
import { Assignment } from "app/shared/models/Assignment";
@Component({
  selector: 'dac-print-dialog',
  templateUrl: './print-dialog.component.html',
  styleUrls: ['./print-dialog.component.scss']
})
export class PrintDialogComponent implements OnInit, OnChanges {
  
  @ViewChild('modal') modal: Modal;
  @Input() isOpen:boolean;
  @Input() assignment:Assignment;
  @Input() hideNotesOption:boolean;

  @Output() close:EventEmitter<void>;
  public printing:boolean;
  private _hasPrinted:boolean;
  private printSettings:PrintSettings;
  private filePrintId:string;

  constructor(private pdfService:PdfService, private alertService:AlertService) {
    this.close = new EventEmitter<void>();
    this.printSettings = new PrintSettings();
    this._hasPrinted = false;
    this.hideNotesOption = false;
   }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    
    if (this.isOpen && !this.modal.isOpened) {
      this.modal.open();
      this._hasPrinted = false
    }
    else if (!this.isOpen && this.modal.isOpened) {
      this.modal.close();
    }
  }

  public get printingComplete() {
    return !this.printing && this._hasPrinted;
  }

  handlePrint() {
    this._hasPrinted = false;
    this.printing = true;
    let url = window.location.href;
    if (this.printSettings.showTherapistNotes) {
      url += "?notes=1";
    }
    // 2 minutes to time out for generating the report.
    let alert = this.alertService.info("Generating PDF Report", 120000);
    this.pdfService.generate(url, this.assignment)
    .then((fileId:string) => {
      this.filePrintId = fileId;
      this.alertService.clearAlert(alert);
      this.printing = false;
      this._hasPrinted = true;
      this.alertService.success("PDF report successfully generated");
    })
    .catch((error) => {
      this.printing = false;
      console.error(error);
      this.alertService.clearAlert(alert);
      this.alertService.error("PDF failed to generate.  Check your internet connection and try again.  Contact customer support if you keep experiencing problems");
    });

    
    // this.handleClose();
  }

  get downloadFileUrl() {
    if (!this.printingComplete) {
      return "";
    }
    return this.pdfService.getPDFUrl(this.filePrintId);
  }

  updateTherapistNoteSettings(event:Event) {
    let target = event.target as HTMLInputElement;
    this.printSettings.showTherapistNotes = target.checked;
  }

  handleClose() {
    this.close.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/print-dialog/print-dialog.component.ts